export default __webpack_public_path__ + "static/media/logingirl.d5fcd110.png";